<h2 mat-dialog-title class="dialog-header">
  <div class="header-left">
    <mat-icon class="header-icon">history</mat-icon>
    DOCUMENT HISTORY
  </div>
  <button type="button" aria-label="Close" (click)="onCancelClick()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
 <!-- No data message -->
 <div *ngIf="!data.docHistoryDtoList?.length" class="no-data">
  No History Available
</div>
<mat-dialog-content *ngIf="data.docHistoryDtoList?.length"> 
  <div class="top">
    <div class="row-split">
      <p><strong>Document ID:</strong> {{ data.documentId }}</p>
      <p><strong>Batch ID:</strong> {{ data.batchId }}</p>
    </div>
    <div class="row-split">
      <p><strong>Create Date:</strong> {{ data.createDate }}</p> 
    </div>
  </div>

  <div  class="bottom">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 full-width-table">

      <ng-container matColumnDef="userGpid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>User Gpid</th>
        <td mat-cell *matCellDef="let row">{{ row.userGpid }}</td>
      </ng-container>

      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>User Name</th>
        <td mat-cell *matCellDef="let row">{{ row.userName }}</td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
        <td mat-cell *matCellDef="let row">{{ row.role }}</td>
      </ng-container>

      <ng-container matColumnDef="fieldName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div style="display: flex; flex-direction: column; align-items: stretch;">
            <span>Field Name</span>
            <mat-form-field appearance="fill" style="width: 150px; margin-top: 4px;">
            <mat-select [(ngModel)]="selectedFieldName" (selectionChange)="applyFilter()" placeholder="Filter" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                <mat-option value="">All</mat-option>
                <mat-option *ngFor="let field of fieldNameOptions" [value]="field">{{ field }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">{{ row.fieldName }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div style="display: flex; flex-direction: column; align-items: stretch;">
            <span>Action</span>
            <mat-form-field appearance="fill" style="width: 80px; margin-top: 4px;">
            <mat-select [(ngModel)]="selectedAction" (selectionChange)="applyFilter()" placeholder="Filter" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                <mat-option value="">All</mat-option>
                <mat-option *ngFor="let action of actionOptions" [value]="action">{{ action }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">{{ row.action }}</td>
      </ng-container>

      <ng-container matColumnDef="actionDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Action Date</th>
        <td mat-cell *matCellDef="let row">{{ row.actionDate }}</td>
      </ng-container>

      <ng-container matColumnDef="comments">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Comments</th>
        <td mat-cell *matCellDef="let row">{{ row.comments }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div> 
</mat-dialog-content>
